import { Directive } from '@angular/core';

@Directive({
  selector: 'ng-template[pluginsAutocompleteNoOptions]',
  standalone: true,
})
export class AutocompleteNoOptionsDirective {}
